/**
 * Pure helpers for MapLibre vector feature picking (G28).
 */

export function catalogLayerIdFromMapLayerId(mapLayerId: string): string | null {
  const prefix = 'layer-';
  if (!mapLayerId.startsWith(prefix)) return null;
  const rest = mapLayerId.slice(prefix.length);
  const suffixes = ['-fill', '-line', '-circle', '-label'] as const;
  for (const suffix of suffixes) {
    if (rest.endsWith(suffix)) {
      return rest.slice(0, -suffix.length);
    }
  }
  return rest.length > 0 ? rest : null;
}

export function resolveFeatureIdFromRenderedFeature(feature: {
  readonly id?: unknown;
  readonly properties?: Readonly<Record<string, unknown>> | null;
}): string | number | null {
  if (feature.id != null && feature.id !== '') {
    return feature.id as string | number;
  }
  const props = feature.properties ?? {};
  const fromId = props.id;
  if (fromId != null && fromId !== '') {
    return fromId as string | number;
  }
  const fromGml = props.gml_id;
  if (fromGml != null && fromGml !== '') {
    return fromGml as string | number;
  }
  return null;
}
